<template>
	<div class="w1200 codeQr">
		<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
		<div class="codeQr_1" v-if="detail.service_qr_one">
			<img class="codeQr_2" :src="detail.service_qr_one" alt="" srcset="">
		</div>
		<div class="codeQr_1" v-if="detail.service_qr_two">
			<img class="codeQr_2" :src="detail.service_qr_two" alt="" srcset="">
		</div>
		<div class="codeQr_1" v-if="detail.service_qr_three">
			<img class="codeQr_2" :src="detail.service_qr_three" alt="" srcset="">
		</div>
		<div class="codeQr_3">{{$t('客服二维码')}}</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				loading:true,
				detail:'',
			}
		},
		created() {
			this.post68e4adcb2856f()
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68e4adcb2856f()
			},
			// 轮播图
			post68e4adcb2856f(){
				this.$api.post(this.$apiUrls.post68e4adcb2856f).then((res) => {
					if(res.code == 1){
						this.detail = res.data
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.codeQr{
		min-height: 564px;
		background: #FFFFFF;
		border-radius: 12px 12px 12px 12px;
		margin: 20px auto 0;
		padding: 130px 0 35px 0;
	}
	.codeQr_1{
		width: 242px;
		height: 242px;
		margin: 0px auto 20px;
		border: 1px dashed #000;
	}
	.codeQr_2{
		width: 240px;
		height: 240px;
	}
	.codeQr_3{
		font-weight: bold;
		font-size: 20px;
		color: #333333;
		text-align: center;
	}
</style>